import "./SpinnerComp.css";
import { defineComponent as d, openBlock as _, createElementBlock as m, createElementVNode as f, normalizeClass as g } from "vue";
import { _ as u } from "./_plugin-vue_export-helper.dad06003.js";
const w = d({
  name: "spinner-comp",
  props: {
    size: {
      type: String,
      default: "65"
    },
    color: {
      type: String,
      required: !1
    }
  },
  methods: {
    partialCirclePath(e, n, t, o, s) {
      return this.partialCirclePaths(
        e,
        n,
        t,
        this.degreesToRadians(o),
        this.degreesToRadians(s)
      ).map((a) => a.join(" ")).join(" ");
    },
    // from http://stackoverflow.com/a/18473154
    partialCirclePaths(e, n, t, o, s) {
      const r = s - o;
      if (r === 0)
        return [];
      const a = t * Math.cos(o) + e, i = t * Math.sin(o) + n, p = t * Math.cos(s) + e, c = t * Math.sin(s) + n, l = Math.abs(r) <= Math.PI ? "0" : "1", h = r < 0 ? "0" : "1";
      return [
        ["M", a, i],
        ["A", t, t, 0, l, h, p, c]
      ];
    },
    degreesToRadians: (e) => e * Math.PI / 180
  }
});
const C = ["width", "height"], M = ["d", "stroke"];
function k(e, n, t, o, s, r) {
  return _(), m("svg", {
    class: "spin-comp",
    width: e.size,
    height: e.size,
    viewBox: "0 0 66 66",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    f("path", {
      class: g(["path", {
        path__stroke: !e.color
      }]),
      d: e.partialCirclePath(33, 33, 30, 0, 270),
      fill: "none",
      stroke: e.color,
      "stroke-width": "6",
      "stroke-linecap": "round"
    }, null, 10, M)
  ], 8, C);
}
const S = /* @__PURE__ */ u(w, [["render", k], ["__scopeId", "data-v-13dc8370"]]);
export {
  S as SpinnerComp
};
//# sourceMappingURL=SpinnerComp.js.map
